import React, { useEffect, useRef, useState } from 'react';

const GoogleDocsViewer = ({ docs }: { docs: Array<{ uri: string }> }) => {
    
    const [iframeTimeoutId, setIframeTimeoutId] = useState(undefined);
    const iframeRef: any = useRef(null);

    useEffect(() => {
        const intervalId: any = setInterval(updateIframeSrc, 1000 * 3);
        setIframeTimeoutId(intervalId);
    }, []);

    function iframeLoaded() {
        clearInterval(iframeTimeoutId);
    }
    function getIframeLink() {
        const url: string = docs?.[0]?.uri || '';
        return `https://docs.google.com/gview?url=${url}&embedded=true`;
    }
    function updateIframeSrc() {
        if (iframeRef?.current) {
            iframeRef.current.src = getIframeLink();
        }
    }

    return (
        <iframe
            title="GoogleDocsViewerIframe"
            //   className={className}
            onLoad={iframeLoaded}
            onError={updateIframeSrc}
            ref={iframeRef}
            src={getIframeLink()}
            height={'99%'}
            width={'100%'}
        />
    );
};

export default GoogleDocsViewer;